/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankCardPageReqVo
 */
export interface BankCardPageReqVo {
    /**
     * 银行卡ID
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    id?: number;
    /**
     * 用户id
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    userId?: number;
    /**
     * 卡类型  1 储蓄卡 2 信用卡
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    cardType?: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BankCardPageReqVo
     */
    cardNumber?: string;
    /**
     * 银行名
     * @type {string}
     * @memberof BankCardPageReqVo
     */
    bankName?: string;
    /**
     * 存款人
     * @type {string}
     * @memberof BankCardPageReqVo
     */
    holder?: string;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    enable?: number;
    /**
     * 卡业务类型 1 佣金收款 2 支付
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    businessType?: number;
    /**
     * 当前页
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    pageNum?: number;
    /**
     * 每页大小
     * @type {number}
     * @memberof BankCardPageReqVo
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the BankCardPageReqVo interface.
 */
export function instanceOfBankCardPageReqVo(value: object): value is BankCardPageReqVo {
    return true;
}

export function BankCardPageReqVoFromJSON(json: any): BankCardPageReqVo {
    return BankCardPageReqVoFromJSONTyped(json, false);
}

export function BankCardPageReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankCardPageReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'holder': json['holder'] == null ? undefined : json['holder'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'pageNum': json['pageNum'] == null ? undefined : json['pageNum'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function BankCardPageReqVoToJSON(json: any): BankCardPageReqVo {
    return BankCardPageReqVoToJSONTyped(json, false);
}

export function BankCardPageReqVoToJSONTyped(value?: BankCardPageReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'cardType': value['cardType'],
        'cardNumber': value['cardNumber'],
        'bankName': value['bankName'],
        'holder': value['holder'],
        'enable': value['enable'],
        'businessType': value['businessType'],
        'pageNum': value['pageNum'],
        'pageSize': value['pageSize'],
    };
}

